import { useCallback, useEffect, useRef } from 'react';
import { useRefCallback } from '../../../callback/ref-callback';
export function useRefMounted(onMounted) {
  var onMountedCallback = useRefCallback(onMounted);
  var ref = useRef(false);
  useEffect(function () {
    onMountedCallback(ref.current = true);
    return function () {
      onMountedCallback(ref.current = false);
    };
  }, []);
  return useCallback(function () {
    return ref.current;
  }, []);
}